export const COOKIE_TYPES = {
  FUNCTIONAL: 'functional',
  REQUIRED: 'required',
  TRACKING: 'tracking',
};
